/**
 * 由 CoCo 源代码计划解包器解包
 *
 * 模块 ID：1516
 */

module.exports = {
  option: "SelectV2_option__25h1S"
}
